var Quiz = (function ($) {
  function shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }

  function User() {
    this.picks = [];
  }

  function Quiz(opts) {
    var self = this;
    self.db = null;
    self.questions = [];
    self.user = new User();
    self.state = { currentQuestion: 0 };

    if (opts) {
      self.db = opts.settings;
    }

    if (!self.db) {
      throw new Error('Quiz has no settings file set.');
    }

    var reload = function () {
      stripped_url = window.location.href.split('?')[0];
      window.location = stripped_url;
    };

    var buildAnswerDiv = function (answer, i) {
      //cycle pad class to reduce padding on left and right
      //of answer box

      var padClass = '';

      if (i % 2 == 0) {
        padClass = 'padding-right-seven';
      } else {
        padClass = 'padding-left-seven';
      }

      var html =
        "<div class='col-lg-6 col-md-6 col-sm-6 col-6 pt-xs-10 pt-40 " +
        padClass +
        "'>";
      html +=
        "<div class='answer-box text-center gotham-book fs-18 fs-xs-16' data-answer-id='" +
        answer.id +
        "'>";
      html += "<div class='answer-box-inner'><div class='image-wrapper'>";
      html +=
        "<img src='" + answer.image + "' alt='" + answer.text + "'></div>";
      html += "<div class='answer-box-cell'>";
      html += answer.text;
      html += '</div></div></div></div>';
      return html;
    };

    var buildQuestionDiv = function (question) {
      // Todo: Convert to styles
      var html =
        "<li class='row'><div class='question-box' data-question-id='" +
        question.id +
        "'>";
      html +=
        "<p class='text-center full-width question-title'>" +
        question.text +
        '</p>';
      html += "<div class='question-answers'><div class='row'>";
      var answers = shuffle(question.answers);

      for (var i = 0; i < answers.length; i++) {
        var answerId = answers[i];
        var answer = self.db.answersDict[answerId];

        if (!answer) {
          throw new Error(
            'Whoops. Answer ' +
              answerId +
              ' does not exist for question ' +
              question.id
          );
        }

        html += buildAnswerDiv(answer, i);
      }

      html += '</div></div></div></li>';
      return html;
    };

    var getCategorySuggestion = function () {
      var pickCategoryCounts = {};
      var maxCategoryCount = -Infinity;
      var numCategoriesWithMax = 0;
      var categories = [];

      for (var i = 0; i < self.user.picks.length; i++) {
        var pick = self.user.picks[i];
        var randomCategory = pick.category[Math.floor(Math.random() * pick.category.length)];

        if (!(randomCategory in pickCategoryCounts)) {
          pickCategoryCounts[randomCategory] = 0;
        }

        pickCategoryCounts[randomCategory] =
          pickCategoryCounts[randomCategory] + 1;
      }

      for (var category in pickCategoryCounts) {
        if (pickCategoryCounts[category] > maxCategoryCount) {
          maxCategoryCount = pickCategoryCounts[category];
        }
      }

      for (var category in pickCategoryCounts) {
        if (pickCategoryCounts[category] == maxCategoryCount) {
          numCategoriesWithMax = numCategoriesWithMax + 1;
        }
      }

      for (var category in pickCategoryCounts) {
        if (pickCategoryCounts[category] == maxCategoryCount) {
          if (numCategoriesWithMax == 1) {
            categories.push(self.db.categoryDict[category]);
            break;
          } else {
            categories.push(self.db.categoryDict[category]);

            if (categories.length >= 2) {
              break;
            }
          }
        }
      }
      return categories;
    };

    function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key, value) {
          vars[key] = value;
        }
      );
      return vars;
    }

    var getUrlParam = function (parameter, defaultvalue) {
      var urlparameter = defaultvalue;
      if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
      }
      return urlparameter;
    };

    var buildAnswerBox = function (answer, category) {
      var links = answer.find('.quiz-picked-link');
      var subtitle = answer.find('.quiz-ending-category-subtitle');
      var coverImage = answer.find('.quiz-ending-category-image');
      var text = answer.find('.quiz-ending-category-text');
      var keynotes = answer.find('.quiz-ending-keynotes');
      var name = answer.find('.quiz-ending-category-name');

      var shopCTA = answer.find('.quiz-ending-shop-cta');
      var imageCTA = answer.find('.quiz-ending-image-cta');

      // Remove
      for (var i = 0; i < category.keynotes.length; i++) {
        keynote = "<li class='keynote'>" + category.keynotes[i] + '</li>';
        keynotes.append(keynote);
      }

      imageCTA.attr("href", category.collection_link);
      shopCTA.attr("href", category.collection_link);
      answer.addClass(category.name.toLowerCase());
      subtitle.html(category.subtitle);
      text.html(category.text);
      links.attr('href', category.gallery_link);
      name.text(category.name);
      coverImage.attr("src", category.image);

      answer.show();
    };

    var quizDone = function () {
      var categories = getCategorySuggestion();

      console.log(categories);

      var featuredItems = $('.quiz-featured-item');
      var fiCounter = 0;

      featuredItems.toArray().forEach(function (item) {
        if(categories[0].featured_products[fiCounter]) {
          console.log($(item.childNodes));
          $(item).attr("href", categories[0].featured_products[fiCounter].link);
          $(item.childNodes[1]).attr("src", categories[0].featured_products[fiCounter].image);
          $(item.childNodes[3]).html(categories[0].featured_products[fiCounter].title);
          item.style.display = 'block';
        }

        fiCounter++;
      })

      //var suggestedCategoryId = categories[0].suggested_category - 1;
      //var suggestedCategory = self.db.categories[suggestedCategoryId];
      var answer1 = $('#quiz-ending-box-1');
      var answer2 = $('#quiz-ending-box-2');
      buildAnswerBox(answer1, categories[0]);

      //if (suggestedCategoryId) {
        //buildAnswerBox(answer2, suggestedCategory);
      //}

      $('#quiz-body').fadeOut('fast', function () {
        $('#quiz-back').hide();
        $('#quiz-dots').hide();
        $('#quiz-title-and-dots').hide();
        $('.browse-gallery').hide();
        $('#quiz-ending').fadeIn('fast', function () {
          checkForMobileWindowScroll('#quiz-ending');
        });
      });
    };

    var moveNext = function () {
      if (self.state.currentQuestion >= self.state.totalQuestions) {
        quizDone();
        return;
      }

      self.flex.flexslider('next');
    };

    var movePrevious = function () {
      if (self.state.currentQuestion > 0) {
        self.state.currentQuestion = self.state.currentQuestion - 1;
        self.flex.flexslider('prev');
      }
    };

    var setAnswer = function (answer) {
      self.user.picks[self.state.currentQuestion] = answer;
      self.state.currentQuestion = self.state.currentQuestion + 1;
      moveNext();
    };

    var checkForMobileWindowScroll = function (div) {
      var width = $(window).width();

      if (width <= 768) {
        var quizBodyOffset = $(div).offset();
        var mobileNavbarHeight = $('.top_bar').height();
        $(window).scrollTop(quizBodyOffset.top - (mobileNavbarHeight + 15));
      }
    };

    var buildQuizUI = function (cb) {
      var html = '';

      for (var i = 0; i < self.db.questions.length; i++) {
        var question = self.db.questions[i];
        html += buildQuestionDiv(question);
      }

      $('#quiz-body .slides').html(html);

      self.flex = $('#quiz-body');

      $('#quiz-body').flexslider({
        animation: 'fade',
        animationSpeed: 200,
        animationLoop: false,
        slideshow: false,
        controlsContainer: $('.quiz-dots'),
        customDirectionNav: $('.custom-navigation a'),
      });

      $('#quiz-num-questions').html(self.db.questions.length);

      $('#quiz-body').on('click', '.answer-box', function () {
        var answerId = $(this).attr('data-answer-id');
        var answer = self.db.answersDict[answerId];
        setAnswer(answer);
        checkForMobileWindowScroll('#quiz-content-wrapper');
      });

      $('#quiz').on('click', '#quiz-back', movePrevious);

      $('#quiz').on('click', '#quiz-begin', function () {
        $('#quiz-start').fadeOut('fast', function () {
          $('#quiz-title-and-dots').fadeIn('fast');
          $('#quiz-body').fadeIn('fast');
          $('#quiz-back').fadeIn('fast');
          $('#quiz-dots').fadeIn('fast');
          checkForMobileWindowScroll('#quiz-content-wrapper');
        });
      });

      $('#quiz').on('click', '#reload-quiz', function () {
        reload();
      });

      if (getUrlParam('pg') === 'home') {
        $('#quiz-title-and-dots').fadeIn('fast');
        $('#quiz-body').fadeIn('fast');
        $('#quiz-back').fadeIn('fast');
        $('#quiz-dots').fadeIn('fast');
        checkForMobileWindowScroll('#quiz-content-wrapper');
      } else {
        $('#quiz-start').fadeIn('fast');
      }
    };

    var setupQuiz = function (cb) {
      // blah
      // create dictionaries for fast lookups
      self.db.categoryDict = {};

      for (var i = 0; i < self.db.categories.length; i++) {
        var category = self.db.categories[i];
        self.db.categoryDict[category.id] = category;
      }

      self.db.answersDict = {};

      for (var i = 0; i < self.db.answers.length; i++) {
        var answer = self.db.answers[i];
        self.db.answersDict[answer.id] = answer;
      }

      self.state.totalQuestions = self.db.questions.length;
      cb();
    };

    setupQuiz(buildQuizUI);
  }

  return Quiz;
})(jQuery);


